import { render, staticRenderFns } from "./VarientBtn.vue?vue&type=template&id=cb15ba20"
import script from "./VarientBtn.vue?vue&type=script&lang=js"
export * from "./VarientBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports